<div style="max-width: 1131px; max-height: 660px; overflow-y: scroll; padding-right: 10px" class="scrollbar">
  <div style="display: flex; flex-direction: column; align-items: flex-start">
    <div style="display: flex; align-items: center">
      <h1 class="schedule-title" mat-dialog-title>{{ 'Partition.ScheduleEvents' | translate }}</h1>
    </div>

    <div style="margin-bottom: 20px">
      <div class="schedule-subtitle">{{ 'Partition.ArmedDisarmedEvents' | translate }}</div>
    </div>

    <div *ngFor="let schedule of schedules; let index = index" style="width: 100%">
      <app-schedule-row
        [first]="index === 0"
        [last]="index === schedules.length - 1 || schedules.length === 1"
        [schedule]="schedule"
        [daysAlreadySelected]="daysAlreadySelected"
        (addChange)="onNewScheduleButtonClick()"
        (deleteChange)="onDeleteButtonClick($event)"
        (scheduleChange)="onScheduleChange($event)"
        [checkInvalid]="checkInvalid != undefined && checkInvalid.scheduleId === schedule.id ? checkInvalid : undefined"
      ></app-schedule-row>

      <div *ngIf="index !== schedules.length - 1" style="border-bottom: 1px solid #dfe2e6; margin-bottom: 20px"></div>
    </div>

    <div style="display: grid; grid-template-rows: 1fr 1fr; gap: 15px; align-items: center">
      <div class="schedule-subtitle">{{ 'Partition.SendEventToCentralQuestion' | translate }}</div>

      <div style="display: flex; align-items: left; justify-content: left; gap: 16px">
        <ui-switch [(ngModel)]="notifyMonitoringCenter" (valueChange)="onSendEventToCentralChange($event)"></ui-switch>
        <div>{{ (notifyMonitoringCenter ? 'Shared.Yes' : 'Shared.No') | translate }}</div>
        <mat-icon
          class="info-icon"
          [tooltipDeitres]="'Partition.AfterTwoAttemptsTooltip' | translate"
          [tooltipCustomLeft]="-6"
          [tooltipCustomTop]="-160"
          tooltipSize="fit"
        >
          info
        </mat-icon>
      </div>
    </div>

    <div
      style="display: flex; align-items: center; justify-content: center; gap: 25px; margin-top: 30px; width: 100%"
      class="schedule-btns-mobiles"
    >
      <button
        type="button"
        mat-raised-button
        class="modal-btn remove-shadow cancel-btn"
        (click)="onCancelClick()"
        style="width: 100%"
      >
        {{ 'Shared.Cancel' | translate }}
      </button>
      <button
        type="button"
        mat-raised-button
        color="primary"
        class="modal-btn remove-shadow"
        (click)="onSaveClick()"
        [disabled]="isLoading"
        style="width: 100%"
      >
        <div style="display: flex; align-items: center; gap: 10px">
          <mat-spinner diameter="22" color="#091e42" *ngIf="isLoading"></mat-spinner>
          {{ 'Settings.ModifySchedule' | translate }}
        </div>
      </button>
    </div>
  </div>
</div>
